<template>
  <div class="edit-module d-flex flex-column">
    <Transition>
      <div
        v-if="keepHeader || !expanded"
        class="d-flex justify-content-between"
      >
        <div><slot name="header"></slot></div>
        <i
          class="fa-regular fa-edit link"
          data-cy="editModuleIcon"
          @click="toggleExpanded"
        ></i>
      </div>
      <div v-else-if="expanded">
        <slot name="body"></slot>
        <div class="d-flex justify-content-between mt-2">
          <Button text="Close" outline @click="handleClose" />
          <Button
            text="Save"
            :saving="saving"
            :disabled="disabled"
            data-cy="editModuleSubmit"
            @click="$emit('submit')"
          />
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
import Button from "@/components/Button.vue";
import Transition from "@/components/Transition.vue";

export default {
  components: {
    Button,
    Transition
  },
  props: {
    keepHeader: {
      type: Boolean,
      default: false
    },
    saving: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["submit", "close", "expand"],
  data() {
    return {
      expanded: false
    };
  },
  methods: {
    handleClose() {
      this.toggleExpanded();
      this.$emit("close");
    },
    toggleExpanded() {
      this.expanded = !this.expanded;
      this.$emit("expand");
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-module {
  padding: 15px 10px;
  border: 1px solid var(--gray-border-color);
  background: var(--white);
  border-radius: 4px;
}
</style>
